// Education page data - replaces education-api calls with hardcoded content

export const WEBINARS_GETTING_STARTED = [
  {
    id: 'getting-started-business-plan',
    titleKey: 'dashboard.learningHub.webinar.startYourBusinessPlan.title',
    descriptionKey: 'dashboard.learningHub.webinar.startYourBusinessPlan.description',
    imagePath: '/s2/raster/start-your-plan-webinar-thumb.png',
    mobileImagePath: null,
    rank: 20,
    businessPhase: 'getting_started',
    videoId: '7sb3yiu1i0',
    externalUrl: null,
    isFeatured: true
  },
  {
    id: 'getting-started-stay-compliant',
    titleKey: 'dashboard.learningHub.webinar.stayCompliant.title',
    descriptionKey: 'dashboard.learningHub.webinar.stayCompliant.description',
    imagePath: '/s2/raster/stay-compliant-webinar-thumb.png',
    mobileImagePath: null,
    rank: 30,
    businessPhase: 'getting_started',
    videoId: 'sohnd3hta0',
    externalUrl: null,
    isFeatured: true
  },
  {
    id: 'getting-started-marketing',
    titleKey: 'dashboard.learningHub.webinar.businessMarketing.title',
    descriptionKey: 'dashboard.learningHub.webinar.businessMarketing.description',
    imagePath: '/s2/raster/marketing-webinar-thumb.png',
    mobileImagePath: null,
    rank: 50,
    businessPhase: 'getting_started',
    videoId: 'sgmagrm549',
    externalUrl: null,
    isFeatured: true
  },
  {
    id: 'getting-started-compliance',
    titleKey: 'dashboard.learningHub.webinar.compliance101.title',
    descriptionKey: 'dashboard.learningHub.webinar.compliance101.description',
    imagePath: '/s2/raster/compliance-101-webinar-thumb.png',
    mobileImagePath: null,
    rank: 60,
    businessPhase: 'getting_started',
    videoId: 'ifcqrmkila',
    externalUrl: null,
    isFeatured: false
  },
  {
    id: 'getting-started-legal-pitfalls',
    titleKey: 'dashboard.learningHub.webinar.legalPitfalls.title',
    descriptionKey: 'dashboard.learningHub.webinar.legalPitfalls.description',
    imagePath: '/s2/raster/legal-pitfalls-webinar-thumb.png',
    mobileImagePath: null,
    rank: 70,
    businessPhase: 'getting_started',
    videoId: 'xr8zr6ygsu',
    externalUrl: null,
    isFeatured: false
  }
];

export const WEBINARS_RUNNING_GROWING = [
  {
    id: 'running-growing-finance',
    titleKey: 'dashboard.learningHub.webinar.financeForGrowth.title',
    descriptionKey: 'dashboard.learningHub.webinar.financeForGrowth.description',
    imagePath: '/s2/raster/finance-for-growth-webinar-thumb.png',
    mobileImagePath: null,
    rank: 40,
    businessPhase: 'running_growing',
    videoId: 'z4eufyhbb8',
    externalUrl: null,
    isFeatured: true
  },
  {
    id: 'running-growing-website',
    titleKey: 'dashboard.learningHub.webinar.websiteBuildingBlock.title',
    descriptionKey: 'dashboard.learningHub.webinar.websiteBuildingBlock.description',
    imagePath: '/s2/raster/website-building-blocks-webinar-thumb.png',
    mobileImagePath: null,
    rank: 80,
    businessPhase: 'running_growing',
    videoId: '6s1fh1zmor',
    externalUrl: null,
    isFeatured: true
  },
  {
    id: 'running-growing-financial-org',
    titleKey: 'dashboard.learningHub.webinar.financialOrganization1.title',
    descriptionKey: 'dashboard.learningHub.webinar.financialOrganization1.description',
    imagePath: '/s2/raster/financial-organization-one-webinar-thumb.png',
    mobileImagePath: null,
    rank: 90,
    businessPhase: 'running_growing',
    videoId: 'hl64l2ns9d',
    externalUrl: null,
    isFeatured: false
  }
];

export const QA_SESSIONS = [
  {
    id: 'qa-blueprint-success',
    titleKey: 'dashboard.learningHub.qaSession.blueprintForSuccess.title',
    rank: 1,
    externalUrl: 'https://events.zoom.us/ev/example-qa-session-1',
    scheduleKey: 'dashboard.learningHub.qaSession.blueprintForSuccessOne.schedule'
  },
  {
    id: 'qa-money-finance',
    titleKey: 'dashboard.learningHub.qaSession.moneyAndFinance.title',
    rank: 2,
    externalUrl: 'https://events.zoom.us/ev/example-qa-session-2',
    scheduleKey: 'dashboard.learningHub.qaSession.moneyAndFinance.schedule'
  },
  {
    id: 'qa-website-builder',
    titleKey: 'dashboard.learningHub.qaSession.websiteBuilder.title',
    rank: 3,
    externalUrl: 'https://events.zoom.us/ev/example-qa-session-3',
    scheduleKey: 'dashboard.learningHub.qaSession.websiteBuilder.schedule'
  }
];
